const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ExpenseNoteQuery: any = {
    ListExpenseNote: Backofficebff + '/expensevoucher/expensevoucherlist',
    PreviewExpenseVoucher: Backofficebff + '/expensevoucher/preview-expense-voucher',
    CreateExpenseVoucher: Backofficebff + '/expensevoucher/create-expense-voucher',
};
